import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { io, Socket } from "socket.io-client";
import { timetables } from "../../../assets/constants";
import { LoaderService } from "../../service/loader.service";
import { Message } from "../../service/message.service";
import { RestService } from "../../service/rest.service";
import { api } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styles: [],
  standalone: false,
})
export class ProjectComponent implements OnInit {
  constructor(
    private router: Router,
    private toast: Message,
    private rest: RestService,
    private loader: LoaderService,
    private http:HttpClient
  ) { }
  private socket!: Socket;
  id = window.location.pathname.split('/')[2]
  currentTab = 0
  project: any = {}
  notice: any = {}
  messages: any[] = []
  notes: { title: string, description: string,date:string }[] = []
  files :any[]= []
  showModalNote = false
  newNote = {
    title: '',
    description: '',
  }
  dateForApi = "";
  urlSocket: string = api.baseUrl + "?event=" + window.location.pathname.split('/')[2];
  message: string = ''
  showCalendar = true
  currentEvent: any = {}
  currentEventSelected: any = {}
  arrayEvents: any[] = []
  suggestedTimeSlots: any[] = []
  currentDate = new Date()
  timesheetStart = "2025-01-01";
  timesheetEnd = "2025-01-31";
  date = "2025-02-22";
  showModalEvent = false;
  modalDelete = false;
  isEditEvent = false
  calendarIsLoading = false
  myOperators: any[] = []
  selectedOperator: any = {}
  selectStartDate: any = null;
  changeSelectStart = true;
  specialModalTimeToShow = ''
  changedSelectStart = false
  role = JSON.parse(localStorage.getItem('user') ?? '{}').role
  filesAdmin :any[]= []
  filesPublic :any[] = []
  baseUrl = api.baseUrl
  documentToDelete :any
  ngOnInit(): void {
    this.getProject()
    this.getNotes()
    this.getProjectFiles()
    this.getProjectPublic()
    this.connectToSocket()
    this.getInitCalendar()
    this.getMyOperators()
  }

  getNoticeDocument() {
    this.rest.get(`/document/notice/${this.notice.id}/documents`).subscribe({
      next: (value: any) => {
        console.log(value);
        this.files = value.map((res: any) => {
          res.ex = res.fileExtension
          if (res.fileSize < 1000) {
            res.w = `${res.fileSize} B`;
          } else if (res.fileSize < 1000 * 1000) {
            res.w = `${(res.fileSize / 1000).toFixed(2)} KB`;
          } else {
            res.w = `${(res.fileSize / (1000 * 1000)).toFixed(2)} MB`;
          }
          return res
        })
      },
    })
  }

  reserveFirstCall(){
        let myEvent = JSON.parse(JSON.stringify(this.currentEvent));

    myEvent.startDate = new Date(this.currentEventSelected.startDate)
    myEvent.projectId = parseInt(this.id)

    this.showModalEvent = false;
    this.loader.on();

   this.rest.post('/booking/reserve', myEvent).subscribe({
    next: (value: any) => {
        this.toast.showMessage('Prima call prenotata','success')
        //         this.currentEvent = {};
        // this.currentEventSelected = {};
        // this.selectStartDate = null;
        // this.changedSelectStart = false;
        // this.suggestedTimeSlots = [];
        // this.refreshCalendar()
        // this.calendarEvents()
this.loader.off(true);
window.location.reload()
      },
      error: (value: any) => {
                this.currentEvent = {};
        this.currentEventSelected = {};
        this.selectStartDate = null;
        this.changedSelectStart = false;
        this.suggestedTimeSlots = [];
        this.refreshCalendar()
        this.toast.showMessage('Errore prenotazione call','error')
        this.loader.off(true);
      },
   })
  }

  timeStringToMilliseconds(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return (hours * 60 * 60 + minutes * 60) * 1000;
  }

  getAvailableSlots() {
    this.rest.get(`/operator/slots?start=${this.timesheetStart}&end=${this.timesheetEnd}`).subscribe({
      next: (value: any) => {
        let availableNewSlots: any[] = []; 
        value.map((val:any)=>{
          val.slots.map((slot:any) => {
            const milliseconds = this.timeStringToMilliseconds(slot);
            availableNewSlots.push({
              name:'Slot prima call',
              dateStart: new Date(val.timestamp + milliseconds - 3600000),
              startDate:new Date(val.timestamp + milliseconds - 3600000),
              dateEnd: new Date(val.timestamp + 1800000 + milliseconds - 3600000),
              endDate: new Date(val.timestamp + 1800000 + milliseconds - 3600000),
              completeEvent: val,
              bgColor: 'green',
              isSlot : true,
            })
          })
        });

          /*return {
            name:'Slot prima call',
            dateStart: new Date(slot.timestamp),
            startDate:new Date(slot.timestamp),
            dateEnd: new Date(slot.timestamp + 1800000),
            endDate: new Date(slot.timestamp + 1800000),
            completeEvent: slot,
            bgColor: 'green',
            isSlot : true,
            ...slot,
          }
        })*/

        this.arrayEvents = [...this.arrayEvents,...availableNewSlots]
        this.loader.off(true);

      },
      error: (value: any) => {
        this.loader.off(true);
      },
    })
  }

  downloadDocument(myFile:any,urlType:string){
    this.loader.on()
    this.http.get(`${api.baseUrl}/document/${urlType}/${myFile.id}/download`, {
      responseType: "blob",
      headers: {
        Authorization: `${api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
    }).subscribe((blob:any) => {
      const url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = myFile.name + '.' + myFile.fileExtension;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      this.loader.off(true);
    });
    
  }

  getInitCalendar() {
    const date = new Date();
    const day = date.getDay();
    const firstDay = new Date(date);
    firstDay.setDate(date.getDate() - ((day + 6) % 7));
    const lastDay = new Date(firstDay);
    lastDay.setDate(firstDay.getDate() + 6);
    const formatDate = (d: Date) => {
      const day = d.getDate().toString().padStart(2, "0");
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    };
    this.timesheetStart = formatDate(firstDay);
    this.timesheetEnd = formatDate(lastDay);
    this.calendarEvents();
  }

  getNewEventsWeek(event: any) {
    console.log(event);

    if (!this.calendarIsLoading) {
      this.calendarIsLoading = true
      const firstDay = new Date(event.firstDate);
      const lastDay = new Date(event.lastDate);
      const dayFirst = firstDay.getDate().toString().padStart(2, "0");
      const monthFirst = (firstDay.getMonth() + 1).toString().padStart(2, "0");
      const yearFirst = firstDay.getFullYear();
      const dayLast = lastDay.getDate().toString().padStart(2, "0");
      const monthLast = (lastDay.getMonth() + 1).toString().padStart(2, "0");
      const yearLast = lastDay.getFullYear();
      this.timesheetStart = `${yearFirst}-${monthFirst}-${dayFirst}`;
      this.timesheetEnd = `${yearLast}-${monthLast}-${dayLast}`;
      this.calendarEvents();
      
    }
  }
  refreshCalendar() {
    this.showCalendar = false;
    setTimeout(() => {
      this.showCalendar = true;
    }, 0);
  }

    formatNumber(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  manageElementsEvent(event: any) {
    const date = new Date(event.startDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    this.date = formattedDate;

    // this.currentEvent.price = this.currentEvent.price;
    // this.currentEvent.userId = this.currentEvent.operator.id;
    // this.selectStartDate = timetables.find((res: any) =>
    //   res.value.includes(
    //     new Date(this.currentEvent.startDate).getHours() +
    //       ":" +
    //       new Date(this.currentEvent.startDate).getMinutes()
    //   )
    // );
    this.getSuggestedSlots();
  }

  getMyOperators() {
    this.loader.on();
    this.rest.get(`/project/${this.id}/operators`).subscribe({
      next: (value: any) => {
        this.loader.off(true);
        this.myOperators = value.map((res: any) => {
          res.fullName = res.firstName + " " + res.lastName;
          return res;
        });
      },
      error: (value: any) => {
        this.loader.off(true);
      },
    });
  }

  getSuggestedSlots() {
    this.loader.on();
    this.rest.get(`/operator/${this.currentEvent.userId}/slot?start=${this.dateForApi}&end=${this.dateForApi}`)
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          if (value[0]?.slots) {
            this.suggestedTimeSlots = value[0].slots;
          } else {
            this.suggestedTimeSlots = [];
          }
        },
        error: (value: any) => {
          this.suggestedTimeSlots = [];
          this.loader.off(true);
        },
      });
  }

  manageCalendar() {
    let myEvent = JSON.parse(JSON.stringify(this.currentEvent));

    myEvent.startDate = new Date(this.dateForApi + ' ' + this.selectStartDate.label)
    myEvent.projectId = parseInt(this.id)

    this.showModalEvent = false;
    this.loader.on();

    let myFunction = !this.isEditEvent
      ? this.rest.post('/booking/reserve', myEvent)
      : this.rest.patch('/booking/reserve', myEvent);
    myFunction.subscribe({
      next: () => {
        this.currentEvent = {};
        this.currentEventSelected = {};
        this.selectStartDate = null;
        this.changedSelectStart = false;
        this.suggestedTimeSlots = [];
        this.loader.off(true);
        this.calendarEvents();
      },
      error: (value: any) => { },
      complete: () => { },
    });
  }

  getEventTime(timestamp: number): string {
    const date = new Date(timestamp);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  }

  dateSelect(dayCalendar: any) {
    this.isEditEvent = false;
    const date = new Date(dayCalendar.date);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    this.dateForApi = `${year}-${month}-${day}`;
    this.currentEvent = {};
    this.showModalEvent = true;
    this.date = formattedDate;
    this.currentDate = date
  }

  getFormattedDate(myDate: Date) {
    const date = new Date(myDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  manageOperator(event: any) {
    this.currentEvent.userId = event.id;
    this.getSuggestedSlots();
  }

  selectSuggestedSlot(slot: string) {
    this.changeSelectStart = false;
    this.selectStartDate = { value: slot, label: slot };
    this.changeSelectStart = true;

    this.adjustDateSelect({ value: slot, label: slot });
  }

  adjustDateSelect(event: any) {
    const [h, m] = event.label.split(":");
    const [day, month, year] = this.date
      .split("/")
      .map((part) => parseInt(part, 10));
    let newDate = new Date(year, month - 1, day, parseInt(h), parseInt(m));
    this.currentEvent.startDate = newDate;
    let editedDate = new Date(
      new Date(newDate).setMinutes(
        new Date(newDate).getMinutes() + 30
      )
    );
    let adjustedDate =
      (editedDate.getHours() >= 10 ? "" : "0") +
      editedDate.getHours().toString() +
      ":" +
      (editedDate.getMinutes() >= 10 ? "" : "0") +
      editedDate.getMinutes().toString();
    let myElementForSelect = timetables.find(
      (timeTab: any) => timeTab?.label == adjustedDate
    );
    this.selectStartDate = event;
  }

  calendarEvents() {
    this.loader.on();
    this.rest.get(
      `/booking/project?start=${this.timesheetStart}&end=${this.timesheetEnd}&project=${this.id}`
    )
      .subscribe({
        next: (value: any) => {
          this.arrayEvents = value.map((event: any) => ({
            name:event.user ? (
              (event.user
                ? event.user.firstName + " " + event.user.lastName
                : "") +
              ((event.description && event.user) ||
                (event.user && !event.description && event.item?.name)
                ? " - "
                : "") +
              (event.description ? event.description : "") +
              (event.description && event.item?.name ? " - " : "") +
              (event.item?.name ? event.item?.name : "")) : 'In assegnazione',
            dateStart: event.startDate,
            dateEnd: event.endDate,
            completeEvent: event,
            // bgColor: this.randomColorById.generateColorFromId(
            //   event?.operator?.id +
            //     event?.operator?.firstName +
            //     event?.operator?.lastName +
            //     event?.operator?.companyId
            // ),
            bgColor: 'red',
            ...event,
          }));
          this.calendarIsLoading = false
          if (this.project.firstCall == false) {
        this.getAvailableSlots()
      }
          this.loader.off(true);
        },
        error: (value: any) => {
          this.loader.off(true);
        },
        complete: () => { },
      });
  }

  connectToSocket() {
    this.socket = io(this.urlSocket, {
      transports: ["websocket"],
      auth:{
        token:('Bearer ' + localStorage.getItem('token'))
      }
    });
    this.socket.on("last", (data: string) => {
      let newMessages = JSON.parse(data).map((res: any) => {
        res.sendDate = this.getFormattedDateComplete(new Date(res.createdAt))
        return res
      })
      this.messages = newMessages;
      let chat = document.getElementById('chat');
      if (chat) {
        setTimeout(() => {
          chat.scrollTop = chat.scrollHeight;
        }, 0);
      }
    });
    this.socket.on("messages", (data: string) => {
      let isBottom = false;
      let chat = document.getElementById('chat');
      if (chat) {
        isBottom = chat.scrollHeight - chat.scrollTop - chat.clientHeight < 5;
      }
      let newMessage = JSON.parse(data)
      newMessage.sendDate = this.getFormattedDateComplete(new Date(newMessage.createdAt))
      this.messages.push(newMessage);
      if (isBottom && chat) {
        setTimeout(() => {
          chat.scrollTop = chat.scrollHeight;
        }, 0);
      }
    });
  }
  
  getFormattedDateComplete(date:Date){
    let myDate = `${new Date(date).getHours()}:${new Date(date).getMinutes() >= 10 ? new Date(date).getMinutes() : ('0' + new Date(date).getMinutes())} - ${(new Date(date).getDay() + 1) >= 10 ? (new Date(date).getDay() + 1): ('0'+ (new Date(date).getDay() + 1))}/${(new Date(date).getMonth() + 1) >= 10 ? (new Date(date).getMonth() + 1): ('0'+(new Date(date).getMonth() + 1))}/${new Date(date).getFullYear()}`
    return myDate
  }

  sendMessage() {
    this.socket.emit(
      'message',
      JSON.stringify({ message: this.message, userId: JSON.parse(localStorage.getItem('user') ?? '{}').id })
    );
    this.message = '';
  }

  getProject() {
    this.rest.get('/project/' + this.id).subscribe({
      next: (value: any) => {
        this.project = value
        this.getNotice(value.noticeId)
        if(value.firstCall == false){
          this.getAvailableSlots()
        }
      },
    })
  }

  getProjectFiles() {
    this.rest.get('/document/list').subscribe({
      next: (value: any) => {
     this.filesAdmin = value
      },
    })
  }

  getProjectPublic() {
    this.loader.on()
    this.rest.get(`/project-document/${this.id}`).subscribe({
      next: (value: any) => {
        this.loader.off(true)
        this.filesPublic = value
      },
      error: (value: any) => {
        this.loader.off(true)
      },
    })
  }

  clickInputFilePublic(){
    let fileInput = document.getElementById('inputFilePublic')
    if(fileInput){
      fileInput.click()
    }
  }

  changeFileInput(event: any) {
    let myFile = event?.target?.files[0]
    if (myFile) {
      let myFormData = new FormData()
      myFormData.append('file', myFile)
      myFormData.append('name',myFile.name)
      myFormData.append('projectId',this.id)
      this.loader.on()
      this.rest.post('/project-document',myFormData).subscribe({
        next:(value)=> {
          this.getProjectPublic()
          this.loader.off(true)
        },
        error:(value)=> {
          this.loader.off(true)
        },
      })
    }
  }

  deleteDocument(file:any){
    this.loader.on()
    this.rest.delete(`/project-document/${file.id}`).subscribe({
      next:(value)=> {
        this.loader.off(true)
        this.getProjectPublic()
      },
      error:(value)=> {
        this.loader.off(true)
        this.getProjectPublic()
      },
    })
  }

  getNotice(noticeId: number) {
    this.rest.get('/notice/' + noticeId).subscribe({
      next: (res: any) => {
        if(res.stanziamentoIncentivo){
        res.stanziamentoIncentivo = this.formatNumber(res.stanziamentoIncentivo.replace('.00', ''))
        res.stanziamentoIncentivoNumber = parseInt(res.stanziamentoIncentivo.replaceAll('.', ''))}
        res.endDate = new Date(res.endDate).getDate() + '-' + (new Date(res.endDate).getMonth() + 1) + '-' + new Date(res.endDate).getFullYear()
        this.notice = res
        this.getNoticeDocument()
      },
    })
  }

  getNotes() {
    this.rest.get('/project/' + this.id + '/notes').subscribe({
      next: (value: any) => {
        this.notes = value.map((res:any)=>{
          res.date = this.getFormattedDateComplete(new Date(res.createdAt))
          return res
        })
      },
    })
  }

  createNote() {
    this.loader.on()
    this.showModalNote = false
    this.rest.post('/project/' + this.id + '/notes', this.newNote).subscribe({
      next: (value: any) => {
        this.loader.off(true)
        this.newNote = {
          title: '',
          description: ''
        }
        this.getNotes()
      },
      error: (err: any) => {
        this.loader.off(true)
      },
    })
  }

  confirmData() { }

}
